<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="Politique de confidentialité" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Hatchi Co., Ltd. (ci-après dénommée « la Société ») exige que les utilisateurs fournissent un minimum d'informations personnelles afin qu'ils puissent utiliser le site en toute tranquillité d'esprit.</span>
            <span class="text">De plus, nous prenons le plus grand soin à protéger les informations personnelles qui nous sont fournies.</span>
            <span class="text">L'approche de notre entreprise en matière de protection des informations personnelles est la suivante.</span>
            <br>
            <span class="text">(1) La Société utilisera les informations des individus, des organisations et des sociétés enregistrées par les membres uniquement pour développer et fournir des fonctions et des services de pointe, et accordera une attention particulière à la protection des informations personnelles des membres.</span>
            <span class="text">(2) Cette politique de confidentialité s'applique uniquement aux services fournis par notre société.</span>
            <span class="text">(3) Sauf indication contraire dans les présentes Conditions, les informations ne seront utilisées à aucune autre fin.</span>
            <span class="text">(4) Sauf indication contraire dans les présentes Conditions, nous ne divulguerons pas vos informations à des tiers.</span>
            <span class="text">(5) Nous effectuerons régulièrement une gestion appropriée en utilisant d'autres méthodes stipulées dans les présentes Conditions.</span>
            <span class="text">(6) Notre société peut modifier la politique de confidentialité sans l'autorisation de l'utilisateur.</span>
            <span class="text">Lorsque notre société apporte des modifications au contenu des informations personnelles acquises, aux méthodes d'utilisation, aux modifications du contenu de la divulgation, etc., nous vous en informerons en publiant un avis sur notre site Web et en le reflétant dans cette politique de confidentialité afin que les utilisateurs puissent être au courant du contenu.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Section 1. Champ d'application de notre politique de confidentialité</span>
            <span class="text">(1) Notre politique de confidentialité s'applique lorsque les membres utilisent nos services.</span>
            <span class="text">(2) Les informations personnelles collectées lorsque les membres utilisent nos services seront gérées conformément à la politique de notre entreprise en matière de protection des informations personnelles.</span>
            <span class="text">(3) Notre politique sur la protection des informations personnelles s'applique uniquement aux services fournis directement par notre société et ne s'applique pas aux services fournis par d'autres organisations ou sociétés.</span>
            <span class="text">(4)L'utilisation de nos services se fait aux propres risques de l'utilisateur.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Section 2. Collecte et utilisation de nos informations personnelles</span>
            <span class="text">(1) Afin de développer et de fournir des fonctions et des services de pointe à nos membres, nous avons besoin de certaines informations personnelles de nos utilisateurs.</span>
            <span class="text">(2) Les utilisateurs sont responsables de la gestion de leur adresse e-mail et de leur mot de passe enregistrés.</span>
            <span class="text">1. Modifiez régulièrement votre mot de passe et nous vous déconseillons d'utiliser des noms, dates de naissance, numéros de téléphone, etc. faciles à deviner pour les autres.</span>
            <span class="text">2. Veuillez ne pas divulguer, prêter ou transférer vos informations personnelles, même si c'est à une connaissance ou à un ami.</span>
            <span class="text">(3) Les informations personnelles collectées ne seront utilisées que dans la mesure nécessaire à la fourniture de nos services et ne seront fournies à aucun tiers, sauf dans les cas suivants.</span>
            <span class="text">1. Lorsqu’une société émettrice de cartes de crédit effectue une enquête pour enquêter sur une utilisation frauduleuse de la carte.</span>
            <span class="text">2. Lors de l'envoi d'e-mails, etc. pour faire de la publicité aux membres.</span>
            <span class="text">3. Lorsque nous confions le traitement des informations personnelles à un sous-traitant avec lequel nous avons conclu un accord de confidentialité concernant les informations personnelles dans la mesure nécessaire pour atteindre la finalité d'utilisation spécifiée par l'utilisateur.</span>
            <span class="text">4. Lorsqu'il est jugé nécessaire de protéger les droits ou la propriété d'autres membres, de tiers ou de la Société, dans le cas où les actions d'un membre au sein de la Société violent les politiques, les annonces ou les conditions d'utilisation de la Société.</span>
            <span class="text">5. Lorsque la divulgation d'informations personnelles est demandée conformément aux dispositions d'autres lois, telles que des ordonnances d'un tribunal ou d'un organisme administratif, ou lorsqu'il est nécessaire de mener une enquête criminelle, d'éliminer ou de prévenir la violation des droits contre des tiers, ou toute autre nécessité similaire.</span>
            <span class="text">(4) Les membres doivent accepter à l'avance l'utilisation par la Société des informations personnelles de la manière spécifiée ci-dessus et ne doivent soulever aucune objection.</span>
            <span class="text">(5) De plus, nous pouvons partager les informations personnelles des membres avec nos partenaires commerciaux dans les cas suivants :</span>
            <span class="text">1. Lorsqu'il y a une raison commerciale, telle que des services spéciaux pour les membres. Dans ce cas, nous demanderons le consentement du membre avant de fournir les informations, et nous ne fournirons pas les informations sans son consentement.</span>
            <span class="text">2. Lors de la création de documents statistiques, de la réalisation d'études de marché ou de l'analyse de données. Dans ce cas, nous fournirons uniquement les informations qui ont été traitées de manière à ce que des personnes spécifiques ne puissent pas être identifiées.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
